<template lang="pug">
  v-container(v-if="show")
    v-card.pa-2(v-if="event!=null")
      v-layout(row).title Selected Event
      router-link(:to="'/event/'+event.id" style="text-decoration:none")
        
        v-layout(row)
          v-flex(xs6 sm4)
            v-img( :src = "imageSrc" width="100px")
            
          v-flex(xs6 sm8)
            div.title {{event.eventName}}
            div {{event.eventDate}}
            div {{event.location}}
    
</template>
<script>
export default {
  name:'SelectedEvent',
  computed:{
    event(){
      return this.$store.state.events.find(el=>{return el.id == this.$store.state.selectedEvent})
    },
    show(){
      return this.$route.params.id != this.$store.state.selectedEvent
    },
    imageSrc(){return this.$store.state.baseImageURL +'th'+ this.event.imageURL+"?alt=media"},
  }
}
</script>

